<template>
  <div
    class="modal"
    :class="{ 'is-active': value }">

    <div class="modal-background"
      @click="close()">
    </div>

    <div class="modal-content is-wide">
      <div class="modal-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Add A Part</p>
          <button
            class="delete"
            aria-label="close"
            @click="close()">
          </button>
        </header>

        <div class="modal-card-body">

          <article 
            v-if="cutSheetParts.length == 0" 
            class="message is-info is-fullwidth">
            <div class="message-body">
              <span>
                There are no parts available.
              </span>
              <!-- <span v-if="this.parts.length != 0 && this.unassignedParts.length == 0">
                All parts for this projects are in this skid.
              </span> -->
            </div>
          </article>

          <table 
            class="table is-fullwidth has-smallish-font" 
            v-else>
            <thead>
              <tr>
                <th 
                  v-for="(header, headerIndex) in headers"
                  :key="headerIndex">
                  {{ header.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr    
                class="v-centered"           
                v-for="part in cutSheetParts"
                :key="part.id">
                <td>
                  {{ part.cutsheet.input_product_master.name }}
                </td>
                <td>
                  {{ part.part_no }}
                </td>
                <td>
                  <div class="text--nowrap">
                    {{ part.output_product_master.name }}
                  </div>
                  <div class="help text--nowrap">
                    {{ lwt(part.output_stocking_unit) }}
                  </div>
                </td>
                <td>
                  {{ part.total_sqft | round(1) }}
                </td>
                <td>
                  {{ part.quantity | round(0) }}
                </td>
                <td>
                  {{ part.qty_stored | round(0) }}
                </td>
                <td class="is-fixed">
                  <div class="flex flex--row">
                    <v-text-field 
                      type="number"
                      is-small
                      placeholder="Quantity to be stored"
                      :rules="[v => +v <= +part.quantity ? true : 'Cannot exceed quantity available']"
                      v-model="part.qty_to_be_stored"/>
                    <button 
                      @click="part.qty_to_be_stored = part.quantity" 
                      class="button is-small">
                      <span class="icon">
                        <i class="fas fa-angle-double-up"/>
                      </span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <footer class="modal-card-foot">
          <button 
            class="button is-primary" 
            :disabled="saving || partsToStore.length == 0"
            :class="{ 'is-loading': saving }"
            @click="addNewItems()">
            Save
          </button>
          <button class="button" @click="close()">
            Cancel
          </button>
        </footer>

      </div>
    </div>
  </div>
</template>

<script>
import VTextField from '@/components/base/VTextField'
import { mapActions, mapMutations } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean
    },
    storageId: {
      type: [String, Number],
      required: true
    }
  },
  components: { VTextField },
  data() {
    return {
      cutSheetParts: [],
      selected: [],
      headers: [
        { label: 'Input Slab', field: 'length_in_str' },
        { label: 'Part No.', field: 'part_no' },
        { label: 'Output Cut Part', field: 'length_in_str' },
        { label: 'Total sqft', field: 'tot_sqft' },
        { label: 'Qty', field: 'quantity' },
        { label: 'Qty Stored', field: 'qty_stored' },
        { label: 'Qty To Store' }
      ],
      allSelected: false,
      saving: false
    }
  },
  computed: {
    partsToStore() {
      return this.cutSheetParts.filter(
        d => d.qty_to_be_stored > 0
      );
    }
  },
  created() {
    this.initialize();
  },
  watch: {
    // allSelected(v) {
    //   if (v) {
    //     this.unassignedParts.forEach(part => {
    //       let index = this.selected.indexOf(part.id);
    //       if (index == -1) {
    //         this.selected.push(part.id);
    //       }
    //     })
    //   } else {
    //     this.selected.splice(0, this.selected.length);
    //   }
    // }
  },
  methods: {
    ...mapActions("storage", ["addStorageUnit"]),
    ...mapMutations("app", ["setNotification"]),
    initialize() {
      this.$http.cutsheetParts.get(
        { per_page: 1000 }
      ).then(resp => {
        resp.data.results.forEach(part => part.qty_to_be_stored = 0);
        this.cutSheetParts = resp.data.results;
      });
    },
    // toggleSelected(partId) {
    //   let index = this.selected.indexOf(partId);
    //   if (index == -1) {
    //     this.selected.push(partId);
    //   } else {
    //     this.selected.splice(index, 1);
    //   }
    // },
    lwt(product) {
      if (product) {
        return `L${product.length_in_str}" x W${product.width_in_str}" x T${product.thick_in_str}"`
      }
    },
    addNewItems() {
      this.saving = true;

      let promises = [];

      this.partsToStore.forEach(part => {
        promises.push(
          this.addStorageUnit({
            storage_id: this.storageId,
            stocking_unit_id: part.output_stocking_unit.id,
            qty: parseInt(part.qty_to_be_stored)
          })
        )
      })

      Promise.all(promises).then(() => {
        this.saving = false;

        this.setNotification({
          type: 'success',
          status: true,
          message: 'New items successfully added to storage'
        });

        this.close(true);
      }).catch(() => {
        this.saving = false
      })
    },
    close(clear=false) {
      this.$emit('input', false);
      if (clear) {
        this.clearData();
      }
    },
    clearData() {
      Object.assign(this.$data, this.$options.data.call(this));
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/table.scss';
@import '@/styles/flexbox.scss';
@import '@/styles/modal.scss';

td.is-fixed {
  min-width: 120px;
}
</style>